import React from "react";
import { withRouter } from "./../../utils/withRouter";

class PagePreloader extends React.Component {

  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      window.scrollTo(0, 0);
      const preloader = document.querySelector('.preloader');
      if (preloader) {
        preloader.style = 'display: block';
      }
      setTimeout(() => {
        const preloaderAfter = document.querySelector('.preloader');
        if (preloaderAfter) {
          preloaderAfter.style = 'display: none';
        }
      }, 900);
    }
  }


  componentWillUnmount() {
      const preloader = document.querySelector('.preloader');
      if (preloader) {
        preloader.style = 'display: block';
      }
  }

    render() {
    return null;
  }
}

export default withRouter(PagePreloader);
